import React from "react";

import "./style.scss";

import {LoginDescription} from "../LoginDescription";
import Features from "../Features";
import {FeaturesDSP} from "../FeaturesDSP";
import {OrderDemoDSP} from "../OrderDemoDSP";
import {SupportedFormatsDSP} from "../SupportedFormatsDSP";
import {AdDescription} from "../AdDescription";
import {Header} from "../Header";
import {useWindowSize} from "../../../constants/useWindiwSize";
import {CheckIcon, HumanIcon, TargetIcon} from "../LoginDescription/icons";

const IconsWrapper = () => {
  const { isMobile } = useWindowSize();
  return (
    <>
      <div className="icon-container wh human">
        <HumanIcon />
      </div>

      {!isMobile && (
        <>
          <div className="icon-container wh human2">
            <HumanIcon />
          </div>
          <div className="icon-container wh target">
            <TargetIcon />
          </div>
          <div className="icon-container check wo">
            <CheckIcon />
          </div>
          <div className="icon-container wo human3">
            <HumanIcon />
          </div>
          <div className="icon-container check2 wo">
            <CheckIcon />
          </div>
          <div className="icon-container check3 wo">
            <CheckIcon />
          </div>
          <div className="icon-container wo human4">
            <HumanIcon />
          </div>
        </>
      )}
    </>
  );
};

const AMMainPage =() => {

  const type = 1;
  console.log('not loaded');
  return (
    <>
      <section
        className={"login-screen dsp"}
      >
        <div className="login-header">
          <Header
            showTabs
            type={type}
            onLoginClick={() => undefined}
            isLoginShow
          />
        </div>
        <div className={"form-group-wrapper"}>
          <div
            className={`form-group-left-box dsp`}
          >
            <IconsWrapper />;

            <LoginDescription
              title1={
                "The most flexible online advertising platform with highest data accuracy"
              }
              description={
                "Reach out to the audience you always wanted to but never had the tool"
              }
              type={1}
            />

          </div>
        </div>
        <div className="image-loading" />
      </section>

      <Features classes={{
        features: 'features',
        featureItemSelected: 'featureSelected',
        featureItemDesktop: 'featureItem',
      }} />
      <FeaturesDSP />
      <OrderDemoDSP />
      <SupportedFormatsDSP />
      <AdDescription />
    </>
  );

}




export default AMMainPage;

